// R1-VISUAL v2 — Real logotype. Renders Edwin's approved logo mark
// (deep navy classic serif "ERF" + brass roofline + tracked "ENTERPRISES LLC").
// Tone switches between light/dark asset so the mark reads on any background.
import React from "react";

const HEIGHT = { sm: 28, md: 40, lg: 56, xl: 76 };

export default function Wordmark({ tone = "dark", size = "md", withTag = false }) {
  const h = HEIGHT[size] || HEIGHT.md;
  const src = tone === "dark"
    ? "/brand/erf_logo_horizontal.jpg"
    : "/brand/erf_logo_horizontal_reversed.jpg";
  const muted = tone === "dark" ? "#64748B" : "rgba(250,247,242,0.75)";

  return (
    <div
      role="img"
      aria-label="ERF ENTERPRISES LLC"
      data-testid="erf-wordmark"
      style={{ display: "inline-flex", flexDirection: "column", alignItems: "flex-start", lineHeight: 1 }}
    >
      <img
        src={src}
        alt="ERF ENTERPRISES LLC"
        style={{
          height: h,
          width: "auto",
          display: "block",
          // Reversed asset ships on a dark bg; blend seamlessly on any darker surface.
          mixBlendMode: tone === "light" ? "screen" : "normal",
        }}
      />
      {withTag && (
        <div
          style={{
            marginTop: 8,
            fontFamily: '"Inter", system-ui, sans-serif',
            fontSize: 11,
            fontWeight: 400,
            letterSpacing: "0.22em",
            textTransform: "uppercase",
            color: muted,
          }}
        >
          General Contracting · Built to Last
        </div>
      )}
    </div>
  );
}
